import { createSelector } from 'reselect';
import { AppState } from '~/store';

const getArtifacts = (state: AppState) => state.workspaceResources.artifacts.byRunId;
const getRunId = (state: AppState) => state.ui.selectedArtifactRunId;

export const getSortedArtifacts = createSelector(
  [getArtifacts, getRunId],
  (runArtifacts, runId) => {
    if (runArtifacts[runId]) {
      const artifacts = Object.values(runArtifacts[runId].byArtifactId);
      artifacts.sort((a, b) => a.fileName.localeCompare(b.fileName));

      return artifacts;
    }

    return [];
  },
);
